import React from 'react';
import type { FormatterProps } from './type';
import { convertToFormattedDateString } from '../../../../helpers';

interface EpisodeDetailsFormatterProps extends FormatterProps {
  type?: 'single' | 'multiple';
  datakey: string | string[];
  isDate?: boolean;
}
const EpisodeDetailsFormatter = ({
  datakey,
  row,
  type = 'multiple',
  isDate = false,
}: EpisodeDetailsFormatterProps) => {
  const getValue = (key: string | string[]) => {
    if (type === 'single') {
      let index = key;
      // only get first value based on the key order
      if (Array.isArray(index)) {
        // try every key until we have the value, otherwise we should return '-'
        for (const k of index) {
          if (row?.last_episode?.details?.[k]) {
            index = k;
            break;
          }
        }
      }
      if (isDate) {
        const date = row?.last_episode?.details?.[index as string];
        if (date) {
          return convertToFormattedDateString(date) || '-';
        }
        return '-';
      }
      return row?.last_episode?.details?.[index as string] || '-';
    }
    if (Array.isArray(key)) {
      // recursively get the value and join with a comma
      const values = key
        .map((k) =>
          isDate
            ? convertToFormattedDateString(row?.last_episode?.details?.[k])
            : row?.last_episode?.details?.[k],
        )
        .filter(Boolean);
      if (values.length === 0) {
        return '-';
      }
      return values.filter((v) => v).join(', ');
    }
    return (
      (isDate
        ? convertToFormattedDateString(row?.last_episode?.details?.[key])
        : row?.last_episode?.details?.[key]) || '-'
    );
  };
  const value: string = getValue(datakey);
  return <span>{value}</span>;
};

export default EpisodeDetailsFormatter;
